import React from "react";
import logo from "../../images/logo-new.png";
import { Link } from "react-router-dom";
import "./navbar.css";

function Navbar() {
  const handleClick = () => {
    console.log("click");
    if (document.getElementById("mobile_nav").style.display === "grid") {
      document.getElementById("mobile_nav").style.display = "none";
    } else {
      document.getElementById("mobile_nav").style.display = "grid";
    }
  };

  return (
    <div id="nav" className="nav_container">
      <Link style={{ textDecoration: "none" }} to={"/"}>
        <div className="logo_cont">
          <img
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            src={logo}
          />
        </div>
      </Link>

      <p className="hamburger_btn" onClick={handleClick}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 20"
          fill="white"
        >
          <path
            fillRule="evenodd"
            d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
            clipRule="evenodd"
          />
        </svg>
      </p>

      <div id="mobile_nav" className="mobile_nav">
        <Link style={{ textDecoration: "none" }} to={"/"}>
          <p
            onClick={() => {
              document.getElementById("mobile_nav").style.display = "none";
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="mobile_nav_item"
          >
            Home
          </p>
        </Link>

        <Link style={{ textDecoration: "none" }} to={"/faqs"}>
          <p
            onClick={() => {
              document.getElementById("mobile_nav").style.display = "none";
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="mobile_nav_item"
          >
            FAQs
          </p>
        </Link>

        <Link style={{ textDecoration: "none" }} to={"/blogs"}>
          <p
            onClick={() => {
              document.getElementById("mobile_nav").style.display = "none";
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="mobile_nav_item"
          >
            Blogs
          </p>
        </Link>

        {/* <Link style={{ textDecoration: "none" }} to={"/#gallery"}>
          <p className="mobile_nav_item">Gallery</p>
        </Link> */}
        <a
          style={{ textDecoration: "none" }}
          href="/#gallery"
          className="mobile_nav_item"
          onClick={() => {
            document.getElementById("mobile_nav").style.display = "none";
          }}
        >
          Gallery
        </a>

        <Link style={{ textDecoration: "none" }} to={"/aboutus"}>
          <p
            onClick={() => {
              document.getElementById("mobile_nav").style.display = "none";
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="mobile_nav_item"
          >
            About Us
          </p>
        </Link>

        <Link style={{ textDecoration: "none" }} to={"/career"}>
          <p
            onClick={() => {
              document.getElementById("mobile_nav").style.display = "none";
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="mobile_nav_item"
          >
            Career
          </p>
        </Link>

        <Link style={{ textDecoration: "none" }} to={"/contactus"}>
          <p
            onClick={() => {
              document.getElementById("mobile_nav").style.display = "none";
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="mobile_nav_item"
          >
            Contact Us
          </p>
        </Link>
      </div>

      <div className="nav_items">
        <Link style={{ textDecoration: "none" }} to={"/"}>
          <p
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="nav_item"
          >
            Home
          </p>
        </Link>

        <Link style={{ textDecoration: "none" }} to={"/faqs"}>
          <p
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="nav_item"
          >
            FAQs
          </p>
        </Link>

        <Link style={{ textDecoration: "none" }} to={"/blogs"}>
          <p
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="nav_item"
          >
            Blogs
          </p>
        </Link>

        {/* <Link style={{ textDecoration: "none" }} to={"#gallery"}> */}
        <a
          style={{ textDecoration: "none" }}
          href="/#gallery"
          className="nav_item"
        >
          Gallery
        </a>
        {/* </Link> */}

        <Link style={{ textDecoration: "none" }} to={"/aboutus"}>
          <p
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="nav_item"
          >
            About Us
          </p>
        </Link>

        <Link style={{ textDecoration: "none" }} to={"/career"}>
          <p
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="nav_item"
          >
            Career
          </p>
        </Link>

        <Link style={{ textDecoration: "none" }} to={"/contactus"}>
          <p
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="nav_item"
          >
            Contact Us
          </p>
        </Link>
      </div>
    </div>
  );
}

export default Navbar;
